export default __webpack_public_path__ + "static/media/AlrtAIMockup.e394b60b.png";